import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-box-set__tile" }
const _hoisted_2 = { class: "product-box-set__segment-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_box_segment_header = _resolveComponent("product-box-segment-header")!
  const _component_product_box_wide_segment_image = _resolveComponent("product-box-wide-segment-image")!
  const _component_product_box_list = _resolveComponent("product-box-list")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-box-set", {'product-box-set--open': $data.isOpen}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_product_box_segment_header, {
        class: "product-box-set__segment-header",
        "product-box-data": _ctx.productBoxData,
        "product-link": _ctx.productLink
      }, null, 8 /* PROPS */, ["product-box-data", "product-link"]),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createVNode(_component_product_box_wide_segment_image, {
        class: "product-box-set__segment-image",
        "product-box-data": _ctx.productBoxData,
        settings: $data.settingsWide,
        "img-src": $options.imgSetSrc,
        "is-box-type-vertical": _ctx.isBoxTypeVertical,
        "is-bottle": _ctx.isBottle
      }, null, 8 /* PROPS */, ["product-box-data", "settings", "img-src", "is-box-type-vertical", "is-bottle"]),
      _cache[2] || (_cache[2] = _createTextVNode()),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "product-box-set__button | button button--secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.isOpen = !$data.isOpen))
        }, _toDisplayString(_ctx.$t('product.set.productsInSet')), 1 /* TEXT */)
      ])
    ]),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _createVNode(_Transition, {
      name: "vue-animation--fade",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_product_box_list, {
          class: "product-box-set__items",
          products: _ctx.productBoxData.articlesInSet,
          "list-type": "box",
          "tracking-list": `${_ctx.trackingAdditional.list} > ${_ctx.productBoxData.name}`
        }, null, 8 /* PROPS */, ["products", "tracking-list"]), [
          [_vShow, $data.isOpen]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ], 2 /* CLASS */))
}